// extracted by mini-css-extract-plugin
export default {"container":"SlideImage_container__PavS+","image":"SlideImage_image__7Xi5X","text":"SlideImage_text__0eePW"};